export const APIUrl = {
  GetPage: '/bff/page',
}
